<template lang="pug">
div
  .my-4
    .text-sm.font-medium.mb-1 {{ getDiagnosisTitle }}
    .text-xs.neutral500--text(v-html="gethtml(getNote)")
  .d-flex.justify-end.mt-4
    v-btn.button-sm(color="primary" depressed :disabled="isDisabled" @click="$emit('viewDetails')") {{ $t('view_details') }}
</template>

<script>
export default {
  props: {
    parentHistory: {
      type: Object,
      required: true
    },
  },
  computed: {
    isDisabled() {
      return this.getDiagnosisTitle.length === 0 && !this.note
    },
    getDiagnosisTitle() {
      const diagnoses = this.parentHistory.consultation?.diagnoses ?? []
      return diagnoses.join(', ')
    },
    getNote() {
      return this.parentHistory.consultation?.note
    }
  },
  methods: {
    gethtml (note) {
      if (!note) return ''
      let text = note.replace(/<img.*?>/g, '')
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
</style>